import { gql } from 'Utils/apolloClient'

const blackoutDateMutation = gql`
  mutation DatesBlockCreate($input: DatesBlockCreateInput!) {
    createBlackoutDate(input: $input) {
      blackoutDate {
        id
        from
        to
        reason
        site {
          id
          name
        }
      }
    }
  }`

export default blackoutDateMutation
